import {__} from '@wordpress/i18n';

export const MIN_EXCERPT_LENGTH = 10;
export const MAX_EXCERPT_LENGTH = 100;
export const MAX_POSTS_COLUMNS = 6;
export const POST_TYPE = [
    {value: 'post', label: __('Posts')},
    {value: 'page', label: __('Pages')},
]
export const MASONRY_POSTS_COLUMNS = 3;